import { render } from "./AppZona.vue?vue&type=template&id=3f8abc94&scoped=true"
import script from "./AppZona.vue?vue&type=script&lang=js"
export * from "./AppZona.vue?vue&type=script&lang=js"

import "./AppZona.vue?vue&type=style&index=0&id=3f8abc94&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8abc94"]])

export default __exports__